import { createSlice } from '@reduxjs/toolkit';
import SubscriptionRepository from 'repositories/loanOfficer/SubscriptionRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'subscription',
  repository: SubscriptionRepository,
  slices: ['createSubscription'],
});

const initialState = {
  ...restSlice.initialState,
};

const loanOfficerSubscriptionSlice = createSlice({
  name: 'loanOfficerSubscription',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default loanOfficerSubscriptionSlice;
export const loanOfficerSubscriptionReducer = loanOfficerSubscriptionSlice.reducer;
export const loanOfficerSubscriptionHooks = restSlice.hooks(
  loanOfficerSubscriptionSlice,
  'loanOfficerSubscriptionReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/loanOfficer/subscriptionSlice.js